import { reactLocalStorage } from "reactjs-localstorage";
const uuid = require("uuid");
const userKey = "igUser";
const uuidKey = "igUuid";

export const generateUUID = () => {
  var userAgent = window.navigator.userAgent;
  var platform = window.platform;
  var language = window.navigator.language;

  var data = userAgent + platform + language;
  const uuidResult = uuid.v5(data, uuid.v5.URL);
  saveUUID(uuidResult);

  return uuidResult;
};

export const getUUID = () => {
  const uuid = reactLocalStorage.get(uuidKey, "");
  return uuid ? uuid : generateUUID();

};

export const saveUUID = (uuidData)=>{
  reactLocalStorage.set(uuidKey, uuidData);
}

export const getUser = () => reactLocalStorage.getObject(userKey);
export const saveUser = (user) => reactLocalStorage.setObject(userKey, user);
export const clearAll = () => {
  const uuidR = getUUID();
  reactLocalStorage.clear();
  saveUUID(uuidR); //UUID should be keep even if browser close session.
};
